import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Divider, Typography } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import ReadAndMore from "./ReadAndMore";
import CryptoTableUtil from "./CryptoTableUtil";
import Container from "@mui/material/Container";
// import CrhtUtil from "./CrhtUtil";

export default function NewsAndUpdateUtil() {
	const [value, setValue] = React.useState("1");

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<Box sx={{ width: "99%", typography: "body1" }}>
			<TabContext value={value}>
				<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
					<TabList onChange={handleChange} aria-label="lab API tabs example">
						<Tab label="Crypto News Updates" value="1" />
						<Tab label="Crypto History Table" value="2" />
						{/* <Tab label="Loss" value="3" /> */}
						{/* <Tab label="Recent investmet" value="4" /> */}
					</TabList>
				</Box>
				<TabPanel value="1">
					<ReadAndMore />
				</TabPanel>
				<TabPanel value="2">
					{/* <CrhtUtil /> */}
					<CryptoTableUtil />/
				</TabPanel>
			</TabContext>
		</Box>
	);
}
